import axios from 'axios';

import { useAppStore } from '@/store/app';
import { getCurrentUserStore, openMessageSessionInvalid } from '@/utils/helper/auth';
import { TOKEN_ERROR_CODE } from '@/constants';
import { isRequiredLoginRoute } from '@/utils/helper';
import { onHandleCreateTransaction, onResponseSentryTransaction } from '@/utils/helper/sentry';

export function $axios() {
	const config = useRuntimeConfig();
	const baseURL = config.VUE_APP_BASE_API;
	const appStore = useAppStore();

	const axiosInstance = axios.create({
		baseURL,
		headers: {
			Accept: 'application/json',
		},
	});

	axiosInstance.interceptors.request.use(function (config) {
		const userStore = getCurrentUserStore();
		const token = userStore ? userStore.authToken : '';
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	});

	// Add a response interceptor
	axiosInstance.interceptors.response.use(
		async function (response) {
			// Any status code that lie within the range of 2xx cause this function to trigger
			appStore.updateIsAuthorized(true);

			try {
				const config = {
					url: response.config.url || '',
					baseURL: response.config.baseURL || '',
					method: response.config.method || '',
				};

				const sentryTransaction = await onHandleCreateTransaction(config);

				if (sentryTransaction) {
					onResponseSentryTransaction(sentryTransaction, response.status);
				}
			} catch (error) {}

			return response;
		},
		function (error) {
			// Any status codes that falls outside the range of 2xx cause this function to trigger
			appStore.updateIsAuthorized(true);

			const router = useRouter();
			const currentRoute = router.currentRoute.value.name;

			if (error.response && error.response.data.errorCode === TOKEN_ERROR_CODE.INVALID_TOKEN_AUTH) {
				appStore.updateIsAuthorized(false);

				if (isRequiredLoginRoute(currentRoute)) {
					openMessageSessionInvalid();
				}
			}
			return Promise.reject(error);
		},
	);
	return axiosInstance;
}
